// src/presentation/pages/ClinicalExamination/sections/MemorySection.tsx
import React from "react";
import { CardTitle } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";
import { booleanRadioValue } from "../types";

interface MemorySectionProps {
  forgetsRecentEvents: boolean | null;
  repeatsQuestions: boolean | null;
  onForgetsRecentEventsChange: (value: boolean) => void;
  onRepeatsQuestionsChange: (value: boolean) => void;
}

export const MemorySection: React.FC<MemorySectionProps> = ({
  forgetsRecentEvents,
  repeatsQuestions,
  onForgetsRecentEventsChange,
  onRepeatsQuestionsChange,
}) => {
  const { t } = useTranslation("patients");
  return (
    <div className=" border-gray-200">
      <div className="pb-3">
        <CardTitle className="text-base font-semibold text-gray-900">
          {t("clinicalSections.memory.title")}
        </CardTitle>
      </div>
      <div className="space-y-6">
        {/* Forget Recent Events */}
        <div>
          <p className="text-sm text-gray-700 mb-3">
            {t("clinicalSections.memory.forgetsQuestion")}
          </p>
          <RadioGroup
            value={booleanRadioValue(forgetsRecentEvents)}
            onValueChange={(val) => onForgetsRecentEventsChange(val === "true")}
            className="flex gap-6"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="true" id="forget-yes" />
              <Label
                htmlFor="forget-yes"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.yes")}
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="false" id="forget-no" />
              <Label
                htmlFor="forget-no"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.no")}
              </Label>
            </div>
          </RadioGroup>
        </div>

        {/* Repeat Questions */}
        <div>
          <p className="text-sm text-gray-700 mb-3">
            {t("clinicalSections.memory.repeatsQuestion")}
          </p>
          <RadioGroup
            value={booleanRadioValue(repeatsQuestions)}
            onValueChange={(val) => onRepeatsQuestionsChange(val === "true")}
            className="flex gap-6"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="true" id="repeat-yes" />
              <Label
                htmlFor="repeat-yes"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.yes")}
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="false" id="repeat-no" />
              <Label
                htmlFor="repeat-no"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.no")}
              </Label>
            </div>
          </RadioGroup>
        </div>
      </div>
    </div>
  );
};
